import React from 'react';
import { Button, Text } from '@/theme/index';
import { useRedirect } from '@/utils/hooks/useRedirect';
import { StyledApiUpgradeCtaCard } from './components';

export function ApiUpgradeCta() {
  const { redirect } = useRedirect();

  const handleRedirect = () => {
    redirect('/upgrade/plan');
  };

  return (
    <StyledApiUpgradeCtaCard>
      <Text variant="h3">Get more reports each month</Text>
      <Button onClick={handleRedirect} variant="contained" color="success">
        Upgrade now
      </Button>
    </StyledApiUpgradeCtaCard>
  );
}
